import { theme } from '@theme';

export const listItemNavBase = (small?: boolean) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  width: '100%',
  padding: '20px 20px 15px',
  color: theme.palette.common.darkGrey7,
  borderBottom: small ? 'none' : `1px solid ${theme.palette.common.lightGrey1}`,
  '&:has(a.active)': {
    backgroundColor: theme.palette.common.feedbackInfo10
  }
});

export const navLinkStyle = {
  display: 'block',
  width: '100%',
  textDecoration: 'none',
  color: 'inherit'
};

export const accountNavLinkStyle = {
  ...navLinkStyle,
  padding: '8px 16px'
};

export const accountListItem = {
  marginTop: '30px',
  width: '100%'
};

export const fullWidthListItem = {
  width: '100%'
};

export const Label = (small?: boolean) => ({
  lineHeight: 1.1,
  color: theme.palette.common.darkGrey2,
  fontWeight: small ? 400 : 600,
  fontSize: small ? '16px' : '18px'
});

export const mobileMenuActionLabel = {
  marginLeft: '5px',
  fontSize: '16px',
  color: theme.palette.common.darkGrey2,
  textDecoration: 'none'
};

export const signedOffMobileMenuHeader = {
  height: '48px',
  paddingBottom: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
};
